import { SSEResponse } from "./sse-stream-service.interface";

export class FatalError extends Error {

    type: string;

    private static FatalErrorName ='FatalError'

    constructor(message: string){
        super(message);
        this.type = FatalError.FatalErrorName
    }

    static isFatalError(err: any): err is FatalError {
        return err.type === FatalError.FatalErrorName
    }
 }

export class BusinessError extends Error {
    error_code: string;
    type: string;
    response?: SSEResponse<unknown>;
    private static BusinessErrorName = 'BusinessError';
    constructor(data:{
        message: string,
        error_code: string,
        response?: SSEResponse<unknown>,
    }) {
        super(data.message);
        this.error_code = data.error_code;
        this.type = BusinessError.BusinessErrorName;
        this.response = data.response;
    }

    static isBusinessError(err: any): err is BusinessError {
        return err.type === BusinessError.BusinessErrorName;
    }
 }
